import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getSettlementReportsQueryKeys } from "Api/Queries/Settlements/useSettlementReportsQuery";
import { putSettlementReportsSettlementsPartyRecordSettlementIDStatus } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

type Parameters = { settlementID: number; isPaid: boolean };

export const useUpdatePartySettlementRecordStatus = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ settlementID, isPaid }: Parameters) =>
        putSettlementReportsSettlementsPartyRecordSettlementIDStatus(
          { isPaid },
          settlementID,
        ),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getSettlementReportsQueryKeys.all,
      });
      onSuccess?.();
    },
    onError,
  });
};
